import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ConsultationPage from './ConsultationPage';
import { lang } from '../../redux/lang/selectors';

const selector = createStructuredSelector({
  lang,
});

const actions = {};

export { ConsultationPage };

export default connect(selector, actions)(ConsultationPage);
